angular.module('bizmetryApp').controller('AgentsTabController', function (
    $scope, $mdDialog, $mdToast, $q, TelemetryAgentService, dialogService, ProfileService, $interval, ConfigurationService
) {

    // ========================================
    // CONSTANTES
    // ========================================

    var REFRESH_INTERVAL_MS = 15000;

    // ========================================
    // ESTADO
    // ========================================

    $scope.agents = [];
    $scope.filteredAgents = [];
    $scope.search = { text: '' };
    $scope.sortOrder = 'asc';
    $scope.loading = true;
    $scope.isDownloading = {};
    $scope.isAnyDownloadInProgress = false;

    $scope.profileId = $scope.profile.id;
    $scope.accountId = $scope.profile.accountId;

    // ========================================
    // REFRESH / LOAD
    // ========================================

    var destroyed = false;
    var isLoading = false;
    var pendingReload = false;
    var requestCanceller = null;
    var statusRefresh = null;
    var cardRefreshMs = null;
    var statsDialogsOpen = 0;

    function startCardRefresh() {
        if (destroyed || statsDialogsOpen || statusRefresh || !cardRefreshMs) return;
        statusRefresh = $interval(function () { loadAgents(false, true); }, cardRefreshMs);
    }

    function pauseCardRefresh() {
        statsDialogsOpen++;
        if (statusRefresh) $interval.cancel(statusRefresh);
        statusRefresh = null;
        pendingReload = false;
        if (requestCanceller) requestCanceller.resolve();
    }

    function resumeCardRefresh() {
        statsDialogsOpen = Math.max(0, statsDialogsOpen - 1);
        if (destroyed || statsDialogsOpen) return;
        loadAgents(true, true);
        startCardRefresh();
    }

    // Preserve object and nested-property identity so Angular updates bindings
    // without rebuilding cards or resetting child component state.
    function updateInPlace(target, source) {
        Object.keys(target).forEach(function (key) {
            if (key.indexOf('$$') !== 0 && !Object.prototype.hasOwnProperty.call(source, key)) delete target[key];
        });
        Object.keys(source).forEach(function (key) {
            var current = target[key], next = source[key];
            if (angular.equals(current, next)) return;
            if (current && next && !Array.isArray(current) && !Array.isArray(next)
                    && typeof current === 'object' && typeof next === 'object') {
                updateInPlace(current, next);
            } else {
                target[key] = angular.copy(next);
            }
        });
    }

    function reconcileAgents(incoming) {
        var existing = new Map($scope.agents.map(function (agent) { return [agent.agentId, agent]; }));
        var next = incoming.map(function (agent) {
            var current = existing.get(agent.agentId);
            if (!current) return agent;
            updateInPlace(current, agent);
            return current;
        });
        $scope.agents.splice.apply($scope.agents, [0, $scope.agents.length].concat(next));
    }

    function loadAgents(force, background) {
        if (destroyed || statsDialogsOpen) return;

        if (isLoading) {
            if (force) {
                pendingReload = true;
            }
            return;
        }

        if (!$scope.profileId || !$scope.accountId) {
            console.error('AgentsTab: missing profileId or accountId');
            $scope.loading = false;
            return;
        }

        isLoading = true;
        if (!background && $scope.agents.length === 0) $scope.loading = true;
        requestCanceller = $q.defer();

        TelemetryAgentService.getAgents($scope.profileId, $scope.accountId, requestCanceller.promise, background)
            .then(function (response) {
                if (destroyed || statsDialogsOpen) return;

                reconcileAgents(response.data || []);
                console.log('📊 Agents loaded:', $scope.agents.length);
                $scope.filterAndSortAgents();
            })
            .catch(function (error) {
                if (destroyed || statsDialogsOpen || error.status === -1) return;

                console.error('AgentsTab: error loading agents', error);
                if (background) return; // Keep the current cards during a transient polling failure.
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Error loading agents')
                        .position('top right')
                        .theme('error-toast')
                        .hideDelay(3000)
                );
                $scope.agents = [];
                $scope.filteredAgents = [];
            })
            .finally(function () {
                requestCanceller = null;

                if (destroyed) return;

                isLoading = false;
                $scope.loading = false;

                if (pendingReload) {
                    pendingReload = false;
                    loadAgents(false);
                }
            });
    }

    // ========================================
    // FILTRADO Y ORDENAMIENTO
    // ========================================

    /**
     * Determina la prioridad de status para ordenamiento:
     * ONLINE (verde) = 1
     * TRANSITION (amarillo) = 2
     * OFFLINE (rojo) = 3
     */
    function getStatusPriority(status) {
        var statusUpper = (status || '').toUpperCase();
        if (statusUpper === 'ONLINE') return 1;
        if (statusUpper === 'OFFLINE') return 3;
        return 2;
    }

    /**
     * Filtra y ordena los agentes
     * Busca en: agentName, profileName, environmentName
     */
    $scope.filterAndSortAgents = function () {
        var searchText = ($scope.search.text || '').toLowerCase().trim();

        var filtered;
        if (!searchText) {
            filtered = $scope.agents.slice();
        } else {
            filtered = $scope.agents.filter(function (agent) {
                var agentName = (agent.agentName || '').toLowerCase();
                var profileName = (agent.profileName || '').toLowerCase();
                var envName = (agent.environmentName || '').toLowerCase();
                return agentName.indexOf(searchText) !== -1 ||
                    profileName.indexOf(searchText) !== -1 ||
                    envName.indexOf(searchText) !== -1;
            });
        }

        filtered.sort(function (a, b) {
            var priorityA = getStatusPriority(a.agentStatus);
            var priorityB = getStatusPriority(b.agentStatus);
            if (priorityA !== priorityB) return priorityA - priorityB;
            var nameA = (a.agentName || '').toLowerCase();
            var nameB = (b.agentName || '').toLowerCase();
            if ($scope.sortOrder === 'asc') return nameA < nameB ? -1 : (nameA > nameB ? 1 : 0);
            else return nameA > nameB ? -1 : (nameA < nameB ? 1 : 0);
        });

        $scope.filteredAgents.splice.apply($scope.filteredAgents,
            [0, $scope.filteredAgents.length].concat(filtered));

        $scope.onlineCount = filtered.filter(function (a) {
            return (a.agentStatus || '').toUpperCase() === 'ONLINE';
        }).length;
        $scope.offlineCount = filtered.length - $scope.onlineCount;
    };

    $scope.filterAgents = $scope.filterAndSortAgents;

    /**
     * Alterna entre ordenamiento ascendente y descendente
     */
    $scope.toggleSortOrder = function () {
        $scope.sortOrder = ($scope.sortOrder === 'asc') ? 'desc' : 'asc';
        $scope.filterAndSortAgents();
    };

    // ========================================
    // HELPERS
    // ========================================

    $scope.getLatencyPercentage = function (agent) {
        return Math.min(100, ((agent.pingLatency || 0) / 500) * 100);
    };

    /**
     * agent.upTime llega como duración en ms (no timestamp) — <bm-duration>
     * espera un "since" (epoch), así que lo convertimos una vez acá para
     * que el formato días/horas/minutos quede consistente con el resto
     * de la app (common/components/duration-badge).
     */
    // Memoizado por valor de entrada: bm-duration usa esto como binding
    // one-way ("since='<'"), y Angular lo re-evalúa en cada digest para
    // detectar cambios. Si devolviera Date.now() - uptimeMs sin cachear,
    // el resultado difiere en ~1ms cada vez que se llama — dos chequeos
    // consecutivos del MISMO digest nunca coinciden, y Angular tira
    // $rootScope:infdig (digest infinito) tras 10 iteraciones.
    var uptimeSinceCache = {};
    $scope.uptimeSince = function (uptimeMs) {
        if (!uptimeMs) return null;
        if (!(uptimeMs in uptimeSinceCache)) {
            uptimeSinceCache[uptimeMs] = Date.now() - uptimeMs;
        }
        return uptimeSinceCache[uptimeMs];
    };

    $scope.formatSyncTime = function (timestamp) {
        if (!timestamp) return 'Never';
        var diff = Date.now() - new Date(timestamp).getTime();
        var minutes = Math.floor(diff / 60000);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);
        if (days > 0) return days + 'd ago';
        if (hours > 0) return hours + 'h ago';
        if (minutes > 0) return minutes + 'm ago';
        return 'Just now';
    };

    $scope.getLogPressureColor = function (pressure) {
        if (pressure >= 80) return '#f44336';
        if (pressure >= 50) return '#ff9800';
        return '#4caf50';
    };

    $scope.getEnvironmentTypeLabel = function (environmentId) {
        return $scope.$parent.getEnvironmentTypeLabel
            ? $scope.$parent.getEnvironmentTypeLabel(environmentId)
            : 'N/A';
    };

    // ========================================
    // MONITORING STATUS HELPERS
    // ========================================

    /**
     * Verifica si una métrica específica del agente tiene alerta activa (status === 'set')
     *
     * @param {object} agent   - el agente
     * @param {string} metric  - 'cpu' | 'memory' | 'latency'
     * @returns {boolean}
     */
    $scope.isMonitoringSet = function (agent, metric) {
        if (!agent || !agent.monitoringConfig) return false;
        var metricConfig = agent.monitoringConfig[metric];
        if (!metricConfig || !metricConfig.enabled) return false;
        return metricConfig.status === 'SET_CONDITION';
    };

    /**
     * Verifica si el agente tiene al menos una alerta de monitoreo activa.
     * Solo aplica cuando el agente está ONLINE.
     *
     * @param {object} agent
     * @returns {boolean}
     */
    $scope.hasMonitoringAlerts = function (agent) {
        if (!agent || (agent.agentStatus !== 'ONLINE' && agent.agentStatus !== 'STALLED')) return false;
        return $scope.isMonitoringSet(agent, 'cpu') ||
            $scope.isMonitoringSet(agent, 'memory') ||
            $scope.isMonitoringSet(agent, 'latency') ||
            $scope.isMonitoringSet(agent, 'pressure');
    };

    // ========================================
    // DIALOG DE DETALLES
    // ========================================

    $scope.openAgentDetailsDialog = function (agent) {
        $mdDialog.show({
            controller: 'AgentDetailsDialogController',
            templateUrl: 'profile/tabs/agents/details/agent-details-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            multiple: true,
            locals: {
                agent: agent,
                profileId: $scope.profileId,
                accountId: $scope.accountId,
                refreshIntervalMs: REFRESH_INTERVAL_MS,
                getEnvironmentTypeLabel: $scope.getEnvironmentTypeLabel,
                formatSyncTime: $scope.formatSyncTime,
                getLogPressureColor: $scope.getLogPressureColor,
                openDownloadDialog: $scope.openDownloadDialog,
                editAgentConfig: $scope.editAgentConfig,
                openAgentLogsDialog: $scope.openAgentLogsDialog,
                openStatsDialog: $scope.openStatsDialog,
                restartAgent: $scope.restartAgent
            }
        });
    };

    // ========================================
    // STATS
    // ========================================

    $scope.openStatsDialog = function (agent) {
        pauseCardRefresh();
        return $mdDialog.show({
            controller: 'AgentStatsDialogController',
            templateUrl: 'profile/tabs/agents/stats/agent-stats-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            multiple: true,
            locals: { agent: agent }
        }).finally(resumeCardRefresh);
    };

    // ========================================
    // DOWNLOAD
    // ========================================

    $scope.openDownloadDialog = function (agent) {
        $mdDialog.show({
            controller: 'DownloadAgentDialogController',
            templateUrl: 'profile/tabs/agents/download/download-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: { agent: agent }
        });
    };

    // ========================================
    // EDIT CONFIG
    // ========================================

    $scope.editAgentConfig = function (agent) {
        $mdDialog.show({
            controller: 'AgentConfigDialogController',
            templateUrl: 'profile/tabs/agents/configuration/agent-config-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: { agent: agent }
        }).then(function (updatedAgent) {

            if (updatedAgent && updatedAgent.agentId) {
                var index = $scope.agents.findIndex(function (a) {
                    return a.agentId === updatedAgent.agentId;
                });
                if (index !== -1) {
                    $scope.agents[index] = updatedAgent;
                }
            }

            loadAgents(true);

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Agent configuration updated')
                    .position('top right')
                    .hideDelay(3000)
            );

        }, function () {
            // cancel
        });
    };

    // ========================================
    // RESTART
    // ========================================

    $scope.restartAgent = function (agent) {
        dialogService.showDecisionDialog(
            'Restart Agent',
            'Are you sure you want to restart agent "' + agent.agentName + '"? This will temporarily interrupt metric collection.'
        ).then(function (decision) {
            if (decision !== 'proceed') return;
            agent.agentStatus = 'RESTARTING';
            TelemetryAgentService.restartAgent(agent.agentId)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Agent restart initiated successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    setTimeout(function () {
                        loadAgents(true);
                    }, 5000);
                })
                .catch(function (error) {
                    agent.agentStatus = 'ONLINE';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error restarting agent: ' + ((error.data && error.data.message) || error.message))
                            .position('top right')
                            .theme('error-toast')
                            .hideDelay(5000)
                    );
                });
        });
    };

    // ========================================
    // STOP
    // ========================================

    $scope.stopAgent = function (agent) {
        dialogService.showDecisionDialog(
            'Stop Agent',
            'Are you sure you want to stop agent "' + agent.agentName + '"? Metric collection will be halted until the agent is restarted.'
        ).then(function (decision) {
            if (decision !== 'proceed') return;
            agent.agentStatus = 'STOPPING';
            TelemetryAgentService.stopAgent(agent.agentId)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Agent stop initiated successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    setTimeout(function () {
                        loadAgents(true);
                    }, 5000);
                })
                .catch(function (error) {
                    agent.agentStatus = 'ONLINE';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error stopping agent: ' + ((error.data && error.data.message) || error.message))
                            .position('top right')
                            .theme('error-toast')
                            .hideDelay(5000)
                    );
                });
        });
    };

    // ========================================
    // LOGS
    // ========================================

    $scope.openAgentLogsDialog = function ($event, agent) {
        $mdDialog.show({
            controller: 'AgentLogsDialogController',
            templateUrl: 'profile/tabs/agents/logs/agent-logs-dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: true,
            fullscreen: true,
            multiple: true,
            locals: { agent: agent }
        });
    };

    // ========================================
    // REFRESH MANUAL + EVENTOS
    // ========================================

    $scope.refreshAgents = function () {
        loadAgents(true);
    };

    $scope.$on('refreshAgents', function () {
        loadAgents(false);
    });

    // ========================================
    // CLEANUP
    // ========================================

    $scope.$on('$destroy', function () {
        destroyed = true;
        $interval.cancel(statusRefresh);
        pendingReload = false;
        if (requestCanceller) {
            requestCanceller.resolve();
            requestCanceller = null;
        }
        console.log('AgentsTab: destroyed');
    });

    // ========================================
    // INIT
    // ========================================

    loadAgents(false);
    // Fetch central config so a pre-deploy sessionStorage cache cannot hide new keys.
    $q.when(ConfigurationService.loadAllConfig()).then(function () {
        if (destroyed) return;
        var refreshMs = Number(ConfigurationService.getFromCache('frontend.agent.cards_refresh_interval_ms'));
        if (!Number.isFinite(refreshMs) || refreshMs <= 0) {
            console.error('AgentsTab: frontend.agent.cards_refresh_interval_ms must be a positive number.');
            return;
        }
        cardRefreshMs = refreshMs;
        startCardRefresh();
    }).catch(function (error) {
        console.error('AgentsTab: unable to load card refresh configuration', error);
    });

});